import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  description: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 'normal',
    lineHeight: 1.4,
    paddingLeft: 53,
    paddingRight: 53,
  },

  imageRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
    height: 130,
  },
  topImage: {
    width: '100%',
    height: 385, //
    objectFit: 'cover',
    marginBottom: 10,
  },
  thumbnail: {
    width: '33%',
    height: 130,
    objectFit: 'cover',
    borderRadius: '8px',
  },
});
